"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import FilterRadioGroup from "@modules/common/components/filter-radio-group"
import { useCatalogSort } from "../catalog-sort-context"

export type SortOptions = "price_asc" | "price_desc" | "created_at"

type SortProductsProps = {
  "data-testid"?: string
}

const SortProducts = ({
  "data-testid": dataTestId,
}: SortProductsProps) => {
  const { t } = useFrontendPreferences()
  const { sortBy, setSortBy } = useCatalogSort()
  const sortOptions = [
    { value: "created_at", label: t.catalog.latest },
    { value: "price_asc", label: t.catalog.priceAsc },
    { value: "price_desc", label: t.catalog.priceDesc },
  ]

  return (
    <FilterRadioGroup
      title={t.catalog.sortBy}
      items={sortOptions}
      value={sortBy}
      handleChange={(value) => setSortBy(value as SortOptions)}
      data-testid={dataTestId}
    />
  )
}

export default SortProducts
